<template>
    <div id="app">

        <el-menu :default-active="activeIndex"
                 class="el-menu-demo"
                 mode="horizontal"
                 background-color="#251F2E"
                 active-text-color="#fff"
                 @select="handleSelect">
            <el-menu-item class="not-highlighted"
                          @click="handleSelect('1')"
                          style="margin-left:10%">
                <img src="./img/logo.png"
                     alt="">
            </el-menu-item>
            <el-menu-item index="1"
                          class="feature-style">Features</el-menu-item>
            <el-menu-item index="3">Online Translator</el-menu-item>
            <el-menu-item index="4"
                          class="user-style">Terms of user</el-menu-item>
            <el-menu-item index="5"
                          style="float:right;">Private Policy</el-menu-item>
        </el-menu>

        <!-- <translate-form v-on:formHandle="translateText"></translate-form>
        <translateOutput v-text="translatedText"></translateOutput> -->
        <router-view></router-view>
    </div>
</template>
<script>
import TranslateForm from './views/TranslateForm'
import TranslateOutput from './views/TranslateOutput'
import router from './router'
export default {
    name: 'App',
    data() {
        return {
            translatedText: '',
            activeIndex: '1',
        }
    },
    components: {
        'translate-form': TranslateForm,
        translateOutput: TranslateOutput,
    },
    created() {
        this.handleSelect('1')
    },
    watch: {
        '$route.params.id'(newValue, oldValue) {
            console.log
            this.activeIndex = this.$route.params.id
                ? this.$route.params.id
                : '1'
        },
    },
    methods: {
        handleSelect(key) {
            console.log(key, this.$route)
            this.activeIndex = key
            switch (key) {
                case '1':
                    this.$router.push('/index')
                    break
                case '2':
                    this.$router.push('/index')
                    break
                case '3':
                    this.$router.push('/TranslateForm')
                    break
                case '4':
                    this.$router.push('/terms')
                    break
                case '5':
                    this.$router.push('/privacy')
                    break
                default:
                    break
            }
        },
        translateText(text, language) {
            const subscriptionKey = 'f1f0abb1e6bf474fa0d7b9e7b193b66d'
            const endpoint = `https://api.cognitive.microsofttranslator.com/translate?api-version=3.0&to=${language}`
            const body = [{ text }]

            this.$http
                .post(endpoint, body, {
                    headers: {
                        'Ocp-Apim-Subscription-Key': subscriptionKey,
                        'Content-Type': 'application/json',
                    },
                })
                .then((response) => {
                    this.translatedText = response.body[0].translations[0].text
                })
                .catch((error) => {
                    console.error('Error:', error)
                })
        },
    },
}
</script>

<style scoped>
#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
}
/* 样式可以根据需要进行调整 */
.el-menu-item.not-highlighted {
    background-color: transparent !important; /* 设置背景为透明 */
    color: #ffffff; /* 设置文字颜色 */
}

.el-menu-item {
    font-size: 18px;
}

.user-style {
    float: right;
    margin-right: 300px;
}
.feature-style {
    margin: 0 3rem;
}
.el-menu-item:hover {
    background: rgb(37, 31, 46) !important;
    color: #fff !important;
}
@media screen and (max-width: 640px) {
    .user-style {
        float: right;
        margin-right: 0px;
    }
    .feature-style {
        margin: 0 0;
    }
}
</style>



// WEBPACK FOOTER //
// src/App.vue